var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRegularActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_11270_76517)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#1D2129"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_11270_76517)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.22217,
    y: 2.22223,
    width: 35.5556,
    height: 35.5556,
    rx: 17.7778,
    fill: "#1D2129"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.77772,
    y: 2.77778,
    width: 34.4444,
    height: 34.4444,
    rx: 17.2222,
    stroke: "white",
    strokeWidth: 1.11111
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9876 11.1159C14.2542 11.1116 15.5209 11.1159 16.7875 11.1159C17.174 11.1202 17.5776 11.0816 17.9469 11.219C18.694 11.4637 19.2436 12.2022 19.2565 12.988C19.2608 14.4049 19.2565 15.8219 19.2608 17.2388C19.265 17.5179 19.2264 17.8013 19.1148 18.0589C18.8872 18.6257 18.3762 19.068 17.7794 19.2097C17.539 19.2698 17.2899 19.2655 17.0452 19.2655C15.7141 19.2655 14.383 19.2655 13.0477 19.2655C12.4895 19.2698 11.9356 19.0164 11.5749 18.5914C11.2744 18.2436 11.1069 17.7884 11.1112 17.329C11.1112 15.9722 11.1112 14.611 11.1112 13.2499C11.1069 12.915 11.1412 12.5801 11.2744 12.2795C11.5577 11.6054 12.2533 11.1288 12.9876 11.1159ZM12.9876 12.4041C12.6741 12.4255 12.4036 12.7089 12.4036 13.0266C12.3993 14.4007 12.4036 15.7747 12.3993 17.1487C12.3993 17.3032 12.3907 17.4621 12.4637 17.6038C12.5668 17.8271 12.8072 17.9774 13.0563 17.9731C14.4861 17.9731 15.9202 17.9774 17.35 17.9731C17.6892 17.9731 17.9812 17.6639 17.9726 17.3247C17.9726 15.8906 17.9769 14.4608 17.9726 13.0266C17.9726 12.6831 17.6549 12.3826 17.3071 12.3998C15.8687 12.3998 14.4303 12.3912 12.9876 12.4041Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6065 11.116C24.0191 11.1074 25.4318 11.116 26.8444 11.1117C27.0935 11.1074 27.3468 11.1332 27.583 11.2147C28.3301 11.4595 28.8797 12.198 28.8883 12.9881C28.8926 14.4479 28.8926 15.9078 28.8883 17.3634C28.884 18.1062 28.4031 18.8147 27.7204 19.0981C27.4713 19.2054 27.2008 19.257 26.9303 19.2527C25.5134 19.2527 24.0964 19.2527 22.6795 19.2527C22.1428 19.257 21.606 19.0208 21.2497 18.6172C20.9276 18.2651 20.7473 17.7928 20.7473 17.3162C20.7473 15.8992 20.7473 14.4823 20.7473 13.0611C20.743 12.6231 20.889 12.1851 21.1595 11.8459C21.503 11.408 22.044 11.1332 22.6065 11.116ZM22.6065 12.4041C22.2759 12.4299 22.0097 12.7433 22.0268 13.0696C22.0268 14.4866 22.0268 15.9035 22.0268 17.3162C22.0139 17.664 22.3274 17.9774 22.6752 17.9688C24.105 17.9688 25.5348 17.9688 26.969 17.9688C27.3125 17.9731 27.613 17.6597 27.6001 17.3205C27.6001 15.8864 27.6044 14.4565 27.6001 13.0224C27.6001 12.6746 27.2738 12.3783 26.926 12.3998C25.4876 12.3998 24.0449 12.3912 22.6065 12.4041Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6487 20.7826C12.8419 20.744 13.0351 20.7397 13.2326 20.7397C14.6066 20.7397 15.9806 20.7397 17.3546 20.7397C18.0974 20.7354 18.8059 21.2077 19.0979 21.8861C19.2181 22.148 19.2653 22.44 19.2653 22.7234C19.2653 24.1146 19.2653 25.5015 19.2653 26.8926C19.2653 27.1674 19.2224 27.4465 19.1108 27.6999C18.8317 28.3826 18.1318 28.8678 17.3933 28.8764C15.9634 28.8807 14.5336 28.8764 13.1038 28.8807C12.7989 28.885 12.4898 28.8248 12.2107 28.6874C11.5623 28.3826 11.1201 27.6913 11.1201 26.9742C11.1201 25.5143 11.1158 24.0588 11.1201 22.5989C11.133 21.7401 11.8028 20.9501 12.6487 20.7826ZM12.8204 22.0708C12.5714 22.1609 12.3953 22.4228 12.4039 22.6891C12.4039 24.106 12.4039 25.5229 12.4039 26.9399C12.3867 27.292 12.7045 27.614 13.0609 27.6011C14.4907 27.6011 15.9205 27.6011 17.3546 27.6011C17.6981 27.6011 17.9944 27.2834 17.9815 26.9399C17.9815 25.5101 17.9858 24.0802 17.9815 22.6504C17.9772 22.3198 17.6852 22.0321 17.3589 22.0278C15.9978 22.0235 14.641 22.0278 13.2798 22.0235C13.121 22.0278 12.9621 22.0149 12.8204 22.0708Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2667 20.7852C22.4599 20.7423 22.6531 20.738 22.8506 20.7423C24.2375 20.7466 25.6244 20.738 27.0113 20.7466C27.7756 20.7552 28.4969 21.2704 28.7631 21.9832C28.879 22.2752 28.9005 22.5929 28.8919 22.902C28.8919 24.276 28.8962 25.6458 28.8876 27.0198C28.8748 27.827 28.2908 28.5827 27.5136 28.806C27.2388 28.8918 26.9511 28.8918 26.6678 28.8875C25.3367 28.8875 24.0056 28.8875 22.6746 28.8875C22.4041 28.8875 22.1335 28.8317 21.8845 28.7201C21.2147 28.4281 20.7467 27.7239 20.7467 26.9897C20.7424 25.6286 20.7467 24.2675 20.7467 22.9063C20.7424 22.6315 20.751 22.3524 20.8368 22.0905C21.0343 21.4379 21.6011 20.9226 22.2667 20.7852ZM22.4384 22.0691C22.1937 22.1635 22.0219 22.4211 22.0305 22.6831C22.0305 24.1 22.0305 25.5169 22.0305 26.9339C22.0219 27.1872 22.1808 27.4363 22.4126 27.5393C22.5629 27.608 22.7304 27.5951 22.8892 27.5951C24.2461 27.5951 25.6072 27.5951 26.964 27.5951C27.2946 27.5994 27.5909 27.3074 27.5995 26.9768C27.6038 25.6028 27.5995 24.2288 27.6038 22.8548C27.6038 22.6959 27.6124 22.5242 27.5351 22.3782C27.4278 22.1506 27.1787 22.0132 26.9297 22.0218C25.5986 22.0218 24.2675 22.0218 22.9365 22.0218C22.769 22.0261 22.593 22.0089 22.4384 22.0691Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_11270_76517",
    x: 0,
    y: 0,
    width: 44.4444,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.44444
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.22222
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_11270_76517"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_11270_76517",
    x: 2.22217,
    y: 2.22223,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.44444,
    dy: 4.44444
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.44444
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_11270_76517"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegularActive);
export default __webpack_public_path__ + "static/media/regularActive.6167d961cd32b9b48aca33e2fe7bac14.svg";
export { ForwardRef as ReactComponent };